import React from 'react';

export function Page01Step02() {
  return (
    <div className="WizardWrapperW" />
  );
}
